/* w-ingredients-v2.js — section « Ingrédients » v2 (piste Ritual).

   Les cartes sont rendues côté serveur (indexables) ; la fiche est une instance unique
   remplie depuis le JSON inline de la section. Plusieurs sections par page sont gérées,
   et `shopify:section:load` réinitialise celles que l'éditeur de thème vient de rendre.
   Aucune dépendance. */
(function () {
  const MOBILE_MAX = 749;
  const CHEVRON =
    '<svg class="w-ingredients-v2__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const isMobile = () => window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;

  function init(root) {
    const jsonTag = root.querySelector('[data-w-ingredients-v2-json]');
    if (!jsonTag) return;

    let groups;
    try {
      groups = JSON.parse(jsonTag.textContent);
    } catch (error) {
      console.warn('[w-ingredients-v2] JSON invalide', error);
      return;
    }
    if (!Array.isArray(groups) || !groups.length) return;

    const find = (selector) => root.querySelector(selector);
    const pageSize = Number(root.dataset.pageSize) || 6;
    const mobileCap = Number(root.dataset.mobileCap) || 4;
    const noun = root.dataset.noun || 'ingrédients';
    const isBlend = root.classList.contains('w-ingredients-v2--blend');

    // Le serveur affiche déjà le panneau de la variante courante (?variant=…).
    const initialPanel = root.querySelector('[data-group-panel]:not([hidden])');
    const state = {
      group: initialPanel ? Number(initialPanel.dataset.groupPanel) : 0,
      page: 0,
      expanded: false,
      open: -1,
      lastFocus: null,
    };

    const panel = () => root.querySelector('[data-group-panel="' + state.group + '"]');
    const items = () => (groups[state.group] || { items: [] }).items || [];

    function layout() {
      const current = panel();
      if (!current) return;

      root.querySelectorAll('[data-group-panel]').forEach((element) => {
        element.hidden = Number(element.dataset.groupPanel) !== state.group;
      });
      root.querySelectorAll('.w-ingredients-v2__tab').forEach((tab) => {
        tab.setAttribute('aria-selected', String(Number(tab.dataset.group) === state.group));
      });

      const cards = Array.from(current.querySelectorAll('[data-card-index]'));
      const total = cards.length;
      const pager = find('.w-ingredients-v2__pager');
      const more = find('.w-ingredients-v2__more');

      if (isMobile()) {
        cards.forEach((card, index) => {
          card.hidden = !state.expanded && index >= mobileCap;
        });
        if (pager) pager.hidden = true;
        if (more) {
          more.hidden = total <= mobileCap;
          more.setAttribute('aria-expanded', String(state.expanded));
          more.innerHTML =
            (state.expanded ? 'Voir moins' : 'Voir les ' + total + ' ' + noun) + ' ' + CHEVRON;
        }
        return;
      }

      const pages = Math.max(1, Math.ceil(total / pageSize));
      state.page = Math.min(Math.max(state.page, 0), pages - 1);
      cards.forEach((card, index) => {
        card.hidden = Math.floor(index / pageSize) !== state.page;
      });
      if (more) more.hidden = true;
      if (!pager) return;

      pager.hidden = pages < 2;
      const prev = find('[data-pager="prev"]');
      const next = find('[data-pager="next"]');
      if (prev) prev.disabled = state.page === 0;
      if (next) next.disabled = state.page >= pages - 1;

      const dots = find('.w-ingredients-v2__dots');
      if (dots) {
        dots.innerHTML = Array.from({ length: pages }, (unused, index) => {
          const current0 = index === state.page ? ' aria-current="true"' : '';
          return (
            '<button type="button" class="w-ingredients-v2__dot" data-page="' +
            index +
            '" aria-label="Page ' +
            (index + 1) +
            '"' +
            current0 +
            '><span></span></button>'
          );
        }).join('');
      }

      const range = find('.w-ingredients-v2__range');
      if (range) {
        const from = state.page * pageSize + 1;
        const to = Math.min(total, state.page * pageSize + pageSize);
        range.textContent = from + '–' + to + ' sur ' + total;
      }
    }

    /** Remplit la fiche. Chaque champ absent masque son élément plutôt que d'en laisser un vide. */
    function fillDrawer() {
      const list = items();
      if (!list.length) return;

      const item = list[state.open];
      if (!item) return;
      const next = list[(state.open + 1) % list.length];

      const title = find('.w-ingredients-v2__drawer-title');
      if (title) title.textContent = item.title || '';

      const media = find('.w-ingredients-v2__drawer-media');
      const image = find('.w-ingredients-v2__drawer-image');
      if (media && image) {
        if (item.image) {
          image.src = item.image;
          image.alt = isBlend && item.title ? item.title : '';
          image.hidden = false;
          media.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
          media.hidden = true;
        }
      }

      const tag = find('.w-ingredients-v2__drawer-tag');
      if (tag) {
        tag.textContent = item.tag || '';
        tag.hidden = !item.tag;
      }

      const text = find('.w-ingredients-v2__drawer-text');
      if (text) {
        text.innerHTML = item.text || '';
        text.hidden = !item.text;
      }

      // Sans bénéfice ni texte long, le point vert resterait seul à l'écran.
      const lead = find('.w-ingredients-v2__lead');
      if (lead) lead.hidden = !item.tag && !item.text;

      const rows = find('.w-ingredients-v2__rows');
      if (rows) {
        rows.innerHTML = '';
        (item.rows || []).forEach((row) => {
          if (!row || !row.k || !row.v) return;
          const line = document.createElement('div');
          line.className = 'w-ingredients-v2__row';
          const key = document.createElement('dt');
          key.textContent = row.k;
          const value = document.createElement('dd');
          value.textContent = row.v;
          line.append(key, value);
          rows.append(line);
        });
        rows.hidden = !rows.children.length;
      }

      const blog = find('.w-ingredients-v2__blog');
      if (blog) {
        blog.hidden = !item.link;
        if (item.link) blog.href = item.link;
        else blog.removeAttribute('href');
      }

      const position = find('.w-ingredients-v2__position');
      if (position) position.textContent = state.open + 1 + ' / ' + list.length;

      const nav = find('.w-ingredients-v2__drawer-nav');
      if (nav) nav.hidden = list.length < 2;

      const nextKind = find('.w-ingredients-v2__next-kind');
      if (nextKind) nextKind.textContent = isBlend ? 'Mélange suivant' : 'Ingrédient suivant';

      const nextName = find('.w-ingredients-v2__next-name');
      if (nextName) nextName.textContent = (next && next.title) || '';

      const thumb = find('.w-ingredients-v2__next-thumb');
      if (thumb) {
        const source = next && (next.thumb || next.image);
        if (source) {
          thumb.src = source;
          thumb.hidden = false;
        } else {
          thumb.removeAttribute('src');
          thumb.hidden = true;
        }
      }
    }

    function openDrawer(index, trigger) {
      const list = items();
      if (!list[index]) return;

      state.open = index;
      if (trigger) state.lastFocus = trigger;
      fillDrawer();

      const drawer = find('.w-ingredients-v2__drawer');
      if (!drawer) return;
      drawer.hidden = false;
      document.body.classList.add('w-ingredients-v2-lock');

      const dialog = find('.w-ingredients-v2__panel-drawer');
      if (dialog) {
        dialog.scrollTop = 0;
        dialog.focus();
      }
    }

    function closeDrawer() {
      state.open = -1;
      const drawer = find('.w-ingredients-v2__drawer');
      if (drawer) drawer.hidden = true;
      document.body.classList.remove('w-ingredients-v2-lock');
      if (state.lastFocus && document.contains(state.lastFocus)) state.lastFocus.focus();
    }

    /** « Suivant » fait aussi tourner la page de la grille, pour rester synchronisé. */
    function step(direction) {
      const total = items().length;
      if (!total) return;
      state.open = (state.open + direction + total) % total;
      if (!isMobile()) {
        state.page = Math.floor(state.open / pageSize);
        layout();
      }
      fillDrawer();
      const dialog = find('.w-ingredients-v2__panel-drawer');
      if (dialog) dialog.scrollTop = 0;
    }

    function selectGroup(index) {
      if (index === state.group || !groups[index]) return;
      state.group = index;
      state.page = 0;
      state.expanded = false;
      if (state.open > -1) closeDrawer();
      layout();
    }

    root.addEventListener('click', (event) => {
      const target = event.target.closest('button, [data-close]');
      if (!target || !root.contains(target)) return;

      if (target.dataset.group !== undefined) selectGroup(Number(target.dataset.group));
      else if (target.classList.contains('w-ingredients-v2__card')) {
        openDrawer(Number(target.dataset.index), target);
      } else if (target.dataset.pager) {
        turnPage(target.dataset.pager === 'next' ? 1 : -1);
      } else if (target.dataset.page !== undefined) {
        goToPage(Number(target.dataset.page));
      } else if (target.classList.contains('w-ingredients-v2__more')) {
        state.expanded = !state.expanded;
        layout();
      } else if (target.dataset.step) {
        step(Number(target.dataset.step));
      } else if (target.hasAttribute('data-close')) {
        closeDrawer();
      }
    });

    root.addEventListener('keydown', (event) => {
      if (state.open < 0) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;

      const dialog = find('.w-ingredients-v2__panel-drawer');
      if (!dialog) return;
      const focusable = Array.from(dialog.querySelectorAll('button, a[href]')).filter(
        (element) => !element.hidden && element.offsetParent !== null
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const currentGrid = () => {
      const current = panel();
      return current && current.querySelector('.w-ingredients-v2__grid');
    };

    /** Change de page desktop en faisant glisser la nouvelle page depuis le côté visé. */
    function goToPage(target) {
      if (isMobile()) return false;
      const pages = Math.ceil(items().length / pageSize);
      if (target < 0 || target >= pages || target === state.page) return false;
      const direction = target > state.page ? 'next' : 'prev';
      state.page = target;
      layout();

      const grid = currentGrid();
      if (grid) {
        grid.style.transform = '';
        grid.classList.remove('is-settling', 'is-slide-next', 'is-slide-prev');
        void grid.offsetWidth;
        grid.classList.add('is-slide-' + direction);
        grid.addEventListener(
          'animationend',
          () => grid.classList.remove('is-slide-next', 'is-slide-prev'),
          { once: true }
        );
      }
      return true;
    }

    /** Page précédente/suivante sur desktop ; sans effet sur mobile (liste « Voir plus »). */
    function turnPage(direction) {
      return goToPage(state.page + direction);
    }

    // Glisser (souris, stylet ou doigt) n'importe où dans la section desktop, hors fiche : la
    // dernière page peut ne compter qu'une carte. Un glissement annule le clic de la carte
    // relâchée, sinon la fiche s'ouvrirait en fin de geste.
    const SWIPE_MIN = 50;
    const outsideDrawer = (event) => !event.target.closest('.w-ingredients-v2__drawer');
    let drag = null;
    let suppressClick = false;

    root.addEventListener('pointerdown', (event) => {
      if (isMobile() || event.button !== 0 || state.open > -1 || !outsideDrawer(event)) return;
      drag = { x: event.clientX, y: event.clientY, id: event.pointerId, moved: false };
    });

    window.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(event.clientY - drag.y)) {
        drag.moved = true;
        drag.grid = currentGrid();
        root.classList.add('is-dragging');
        if (drag.grid) drag.grid.classList.remove('is-settling', 'is-slide-next', 'is-slide-prev');
      }
      if (!drag.moved || !drag.grid) return;

      // La grille suit le geste ; freinée quand il n'y a pas de page de ce côté.
      const pages = Math.ceil(items().length / pageSize);
      const blocked = (dx > 0 && state.page === 0) || (dx < 0 && state.page >= pages - 1);
      drag.grid.style.transform = 'translateX(' + dx * (blocked ? 0.2 : 0.6) + 'px)';
    });

    const endDrag = (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      const grid = drag.grid;
      let turned = false;
      if (drag.moved) {
        suppressClick = true;
        // Le clic éventuel part juste après pointerup ; sans clic, ne pas bloquer le suivant.
        setTimeout(() => {
          suppressClick = false;
        }, 0);
        if (Math.abs(dx) >= SWIPE_MIN) turned = turnPage(dx < 0 ? 1 : -1);
      }
      if (grid && !turned) {
        grid.classList.add('is-settling');
        grid.style.transform = '';
        setTimeout(() => grid.classList.remove('is-settling'), 300);
      }
      drag = null;
      root.classList.remove('is-dragging');
    };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    root.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    // Les images et liens sont glissables nativement, ce qui volerait le geste.
    root.addEventListener('dragstart', (event) => {
      if (outsideDrawer(event)) event.preventDefault();
    });

    // Swipe horizontal du trackpad (deux doigts) : un geste = une page, puis pause le temps
    // que l'inertie du trackpad retombe.
    let wheelAccum = 0;
    let wheelLockUntil = 0;
    root.addEventListener(
      'wheel',
      (event) => {
        if (isMobile() || state.open > -1) return;
        if (!outsideDrawer(event)) return;
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        event.preventDefault();
        const now = Date.now();
        if (now < wheelLockUntil) return;
        wheelAccum += event.deltaX;
        if (Math.abs(wheelAccum) < 60) return;
        turnPage(wheelAccum > 0 ? 1 : -1);
        wheelAccum = 0;
        wheelLockUntil = now + 600;
      },
      { passive: false }
    );

    let wasMobile = isMobile();
    window.addEventListener('resize', () => {
      if (isMobile() === wasMobile) return;
      wasMobile = isMobile();
      layout();
    });

    /**
     * Suit la variante sélectionnée. Un panneau porte les ids des variantes qu'il couvre :
     * celles dont `custom.picker_flavor` figure dans les `picker_flavors` de son groupe, ou
     * celles qui partagent un même `theme.variant_content`. Dans ce second cas, une variante
     * sans jeu propre retombe sur le panneau des ingrédients produit (`data-default-panel`),
     * et la section se masque s'il n'existe pas.
     */
    function onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;

      const productId = root.dataset.productId;
      const eventProduct = event.detail.product;
      if (productId && eventProduct && eventProduct.id && String(eventProduct.id) !== productId) {
        return;
      }

      const id = String(variant.id);
      const panels = Array.from(root.querySelectorAll('[data-group-panel][data-variant-ids]'));
      const target = panels.find((element) =>
        (element.dataset.variantIds || '')
          .split(',')
          .filter(Boolean)
          .includes(id)
      );
      if (!root.hasAttribute('data-variant-sets')) {
        if (target) selectGroup(Number(target.dataset.groupPanel));
        return;
      }

      const resolved = target || root.querySelector('[data-group-panel][data-default-panel]');
      root.classList.toggle('is-variant-empty', !resolved);
      if (resolved) selectGroup(Number(resolved.dataset.groupPanel));
    }

    root.wIngredientsV2Api = { onVariantChange: onVariantChange };
    layout();
  }

  function boot() {
    document.querySelectorAll('[data-w-ingredients-v2]').forEach((element) => {
      if (element.dataset.wIngredientsV2Ready === 'true') return;
      element.dataset.wIngredientsV2Ready = 'true';
      init(element);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('on:variant:change', (event) => {
    document.querySelectorAll('[data-w-ingredients-v2]').forEach((element) => {
      if (element.wIngredientsV2Api) element.wIngredientsV2Api.onVariantChange(event);
    });
  });
})();
